import { useEffect, useState, useCallback } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import InfoIcon from '../../Assets/InfoIcon';
import { Placement } from 'react-bootstrap/esm/types';
import Constants from '../../utils/Constants';
import { feedlotManagerFeatures } from '../../apps/feedlotManager/featureFlags/feedlotManagerFeatures';

const { isFM241758On_FeedCallTotalCallReduceFed } = feedlotManagerFeatures;

export const InformationalTooltip = ({
    tooltipContent,
    iconClassName,
    placement = 'top',
    width = '24px',
    title,
    autoShow = false,
}: {
    tooltipContent: string;
    iconClassName?: string;
    placement?: Placement;
    width?: string;
    title?: string;
    autoShow?: boolean;
}) => {
    const [show, setShow] = useState<boolean>(false);

    useEffect(() => {
        if (autoShow && isFM241758On_FeedCallTotalCallReduceFed) {
            setShow(true);
            const timer = setTimeout(
                () => setShow(false),
                Constants.infoToolTipTime,
            );
            return () => clearTimeout(timer);
        }
    }, [autoShow]);

    const handleToggle = useCallback(
        (isVisibleTooltip: boolean) => setShow(isVisibleTooltip),
        [],
    );

    const renderInformationalTooltip = props => {
        return (
            <Tooltip {...props}>
                {title && <strong>{title}</strong>}
                <div>{tooltipContent}</div>
            </Tooltip>
        );
    };

    return (
        <OverlayTrigger
            placement={placement}
            overlay={renderInformationalTooltip}
            show={show}
            onToggle={handleToggle}
        >
            <span className="ms-1 my-1">
                <InfoIcon style={{ width: width }} className={iconClassName} />
            </span>
        </OverlayTrigger>
    );
};
